import { TextField } from '@mui/material'
import React, { Fragment } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import { actualizaMarcaBebidasMezcalCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../redux/AppDucks'
import estilos from './MarcasMezcalComponent.module.css'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect'
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import moment from 'moment'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';

function MarcasBebidaMezcalComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const [editar, setEditar] = React.useState(false)

    const [marca, setMarca] = React.useState(props?.data?.marca?.toUpperCase())
    const [numeroderegistroimpi, setNumeroRegistro] = React.useState(props?.data?.numeroderegistroimpi?.toUpperCase())
    const [idtipomarca, setTipoMarca] = React.useState(props?.data?.idtipomarca == 1 ? 'MIXTA' : props?.data?.idtipomarca == 2 ? 'NOMINATIVA' : props?.data?.idtipomarca == 3 ? 'TRIDIMENCIONAL' : '')
    const [productor, setProductor] = React.useState(props?.data?.productor?.toUpperCase())
    const [maquilador, setMaquilador] = React.useState(props?.data?.maquilador?.toUpperCase())

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.marcasproductoconmezcalclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.marcasproductoconmezcalclientehistorial)
        setOpenModalHistorial(true)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 250,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
                            <h3 className='text-center'><b>ADVERTENCIA</b></h3>
                            <p className='mt-3'>¿Está seguro que desea actualizar la información de la marca seleccionada?</p>
                        </Typography>
                        <br />
                        <ThemeProvider theme={theme}>
                            <div className='row'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }

    const btnContinuar = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        await dispatch(actualizarLoadingApp_true())
        let tipomarca = ''
        if (idtipomarca == 'MIXTA') tipomarca = 1
        if (idtipomarca == 'NOMINATIVA') tipomarca = 2
        if (idtipomarca == 'TRIDIMENCIONAL') tipomarca = 3
        let fechainscripcion = new Date(fechaHoy).toISOString()

        let dataActualizar = {
            datacambio: {
                marca: marca?.toUpperCase(), numeroderegistroimpi: numeroderegistroimpi?.toUpperCase(), idtipomarca: tipomarca,
                productor: productor?.toUpperCase(), maquilador: maquilador?.toUpperCase(),
                idmarcasproductocliente: props?.data?.idmarcasproductocliente
            },
            idmarcasproductocliente: props?.data?.idmarcasproductocliente, usuariocambio: dataUser?.[0]?.usuario, fechacambio: fechainscripcion
        }
        await dispatch(actualizaMarcaBebidasMezcalCliente(dataActualizar))
        handleCloseModal()
        setEditar(false)
        props?.setIsModificacion(true)
        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 container2">
                        <div className={`${estilos.lista}`}>
                            <ol className={`${estilos.ol}`}>
                                <li className={`${estilos.li}`}>
                                    <div className={`${estilos.circulo}`}>
                                        <b style={{ width: '100%', textAlign: 'center' }}>{Number(props?.index) + 1}</b>
                                    </div>
                                    <div className={`${estilos.card} ${estilos.cardHtml}`} style={{ marginTop: '-10%' }}>
                                        <div className={props?.data?.isbaja ? `${estilos.cardHeaderBaja}` : `${estilos.cardHeader}`}>
                                            <h4 style={{ margin: 0 }}>MARCA: {marca} </h4>
                                        </div>
                                        <div className={`${estilos.cardBody} row`}>
                                            {!editar &&
                                                <div className='row' style={{ margin: 0, padding: 0 }}>
                                                    {props?.data?.isbaja == false &&
                                                        <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                            <Tooltip title="Ver historial de cambios">
                                                                <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                                    <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    }
                                                    <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}><label><b>Número de registro: <br /> </b> {numeroderegistroimpi} </label> </div>
                                                    <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}><label><b>Tipo de marca: <br /> </b> {idtipomarca} </label> </div>
                                                    <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Titularidad: <br /> </b>
                                                        {(props.data.idtitularidaddemarca == 1 ? 'Marca propia' :
                                                            props.data.idtitularidaddemarca == 2 ? 'Marca propia en trámite' :
                                                                props.data.idtitularidaddemarca == 3 ? 'Marca de licencia de uso autorizado' :
                                                                    props.data.idtitularidaddemarca == 4 ? 'Marca cesión de derechos autorizada' :
                                                                        props.data.idtitularidaddemarca == 5 ? 'Marca de licencia de uso en trámite' :
                                                                            props.data.idtitularidaddemarca == 6 ? 'Marca cesión de derechos en trámite' :
                                                                                '')?.toUpperCase()} </label>
                                                    </div>
                                                    {props?.data?.productor != '' && props?.data?.productor != null && props?.data?.productor != undefined &&
                                                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Productor: <br /> </b> {productor} </label> </div>
                                                    }
                                                    {props?.data?.maquilador != '' && props?.data?.maquilador != null && props?.data?.maquilador != undefined &&
                                                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Maquilador: <br /> </b> {maquilador} </label> </div>
                                                    }
                                                    {!props?.data?.isbaja && !editar && dataUser?.[0]?.idrol == 1 && 
                                                        <div className="col-md-12 mt-3">
                                                            <Button variant="contained" color="primary" style={{ width: '65%' }} onClick={() => setEditar(true)}>Editar marca</Button>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {editar &&
                                                <div className='row' style={{ margin: 0, padding: 0 }}>
                                                    <div className="col-md-6 mt-3 ps-5 pe-5 text-start">
                                                        <TextField id="standard-basic" label='Número de registro' variant="standard" hiddenLabel style={{ width: '100%' }}
                                                            value={numeroderegistroimpi} onChange={e => setNumeroRegistro(e.target.value?.toUpperCase())} disabled={!editar} />
                                                    </div>
                                                    <div className="col-md-6 mt-3 ps-5 pe-5 text-start">
                                                        <FormControl variant="standard" style={{ width: '100%' }}>
                                                            <InputLabel htmlFor="demo-customized-select-native">Tipo de marca</InputLabel>
                                                            <NativeSelect id="demo-customized-select-native" disabled={!editar}
                                                                value={idtipomarca} onChange={e => setTipoMarca(e.target.value)} >
                                                                <option value="MIXTA">MIXTA</option>
                                                                <option value="NOMINATIVA">NOMINATIVA</option>
                                                                <option value="TRIDIMENCIONAL">TRIDIMENCIONAL</option>
                                                            </NativeSelect>
                                                        </FormControl>
                                                    </div>
                                                    <div className="col-md-12 mt-3 ps-5 pe-5 text-start">
                                                        <TextField id="standard-basic" label='Nombre de marca' variant="standard" InputLabelProps={{ shrink: true }} hiddenLabel style={{ width: '100%' }}
                                                            value={marca} onChange={e => setMarca(e.target.value?.toUpperCase())} disabled={!editar} />
                                                    </div>
                                                    {props?.data?.productor != '' && props?.data?.productor != null && props?.data?.productor != undefined &&
                                                        <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                                            <TextField id="standard-basic" label='Productor' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                                                value={productor} onChange={e => setProductor(e.target.value?.toUpperCase())} disabled={!editar} />
                                                        </div>
                                                    }
                                                    {props?.data?.maquilador != '' && props?.data?.maquilador != null && props?.data?.maquilador != undefined &&
                                                        <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                                            <TextField id="standard-basic" label='Maquilador' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                                                value={maquilador} onChange={e => setMaquilador(e.target.value?.toUpperCase())} disabled={!editar} />
                                                        </div>
                                                    }
                                                    <div className='row mt-4'>
                                                        <div className='col-6 col-md-6 justify-content-center'>
                                                            <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                                                        </div>
                                                        <div className='col-6 col-md-6 justify-content-center'>
                                                            <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                {modalComponent()}
                {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Marca de Bebida con Mezcal"} />}
            </ThemeProvider>
        </Fragment >
    )
}

export default MarcasBebidaMezcalComponent